/* global window */
import React from 'react';
import PropTypes from 'prop-types';
import Product from '../../Product';

const SponsoredProduct = props => {
  const {
    link, sku, brand, ribbon, className, adId, listIndex, ...rest
  } = props;

  const handleClick = () => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ti.product.click',
        eventData: {
          nonInteraction: false,
          category: 'Landing Page - Sponsored Brand Products',
          action: 'Product Click',
          label: `Click of ${sku} - ${brand}`,
          products: [
            {
              sku,
              position: listIndex,
              list: 'Landing Page - Sponsored Brand Products Carousel',
              quantity: 1,
              ad_id: adId,
              affiliation: 'citrus',
            },
          ],
        },
      });
    }
  };

  return (
    <div onClick={handleClick} role="presentation" className={className}>
      <Product
        {...rest}
        link={link}
        sku={sku}
        brand={brand}
        brandTag="p"
        ribbon={ribbon && { ...ribbon, url: undefined }}
      />
    </div>
  );
};

SponsoredProduct.propTypes = {
  ...Product.propTypes,
  className: PropTypes.string,
  adId: PropTypes.string,
  listIndex: PropTypes.number,
};

SponsoredProduct.defaultProps = {
  ...Product.defaultProps,
  className: undefined,
  adId: undefined,
  listIndex: undefined,
};

export default SponsoredProduct;
